import React from "react";
import { Outlet } from "react-router-dom";

const LayoutCuentas = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutCuentas;
